import { DatePicker } from 'ComponentLibrary'
import { Control, Controller, FieldErrors, FieldValues, Path, UseControllerProps } from 'react-hook-form'
import { ComponentProps } from 'react'
import { get } from 'lodash'
import { FormControl, FormHelperText } from '@mui/material'

type FormDatePickerProps<FormInput extends FieldValues> = {
    control: Control<FormInput>
    name: Path<FormInput>
    errors?: FieldErrors<FormInput>
    size?: 'small' | 'medium'
    rules?: UseControllerProps<FormInput>['rules']
} & ComponentProps<typeof DatePicker>

/**
 * Date Picker component for use with react-hook-form
 * @deprecated Use `FormDatePicker` from the Piazza component library for new work.
 */
export default function FormDatePicker<FormInput extends FieldValues>(props: FormDatePickerProps<FormInput>) {
    const { control, name, minWidth = '100%', size = 'medium', disabled = false, required, errors, rules, ...rest } = props

    const error = get(errors, name)
    const errorMessage = error?.message?.toString()

    const rulesWithOverride = {
        required: required ? { value: true, message: 'Pflichtfeld' } : undefined,
        ...rules,
    }

    return (
        <Controller
            name={name}
            control={control}
            rules={rulesWithOverride}
            render={({ field: { onChange, value, ...fieldProps }, formState: { errors } }) => {
                return (
                    <FormControl fullWidth>
                        <DatePicker
                            {...fieldProps}
                            minWidth={minWidth}
                            required={required}
                            value={value}
                            disabled={disabled}
                            onChange={onChange}
                            hasError={!!errors[name]}
                            size={size}
                            {...rest}
                        />
                        {
                            <FormHelperText
                                variant="outlined"
                                sx={{ fontSize: '0.5rem', position: 'absolute', bottom: '-12px', alignSelf: 'flex-end' }}
                                margin="dense"
                                error
                            >
                                {errorMessage || ' '}
                            </FormHelperText>
                        }
                    </FormControl>
                )
            }}
        />
    )
}
